import ComponentManager from '@/Management/ComponentManager';
import ViewFactory from '@/Factories/ViewFactory';
import ChangelogPopupViewModel from '@/Components/ChangelogGrid/ChangelogPopupViewModel';
import ChangelogPopup from '@/Components/ChangelogGrid/ChangelogPopup';

export default class ChangelogPopupFactory extends ViewFactory {

    public viewModel: ChangelogPopupViewModel;

    public constructor(private params: any) {
        super(params);
    }

    public getRegion(): string {
        return 'Modal';
    }

    public getView(): JQuery<HTMLElement> {
        if (!this.viewModel) {
            this.viewModel = new ChangelogPopupViewModel({
                pdoId: this.params.pdoId,
                pdTypeName: this.params.pdTypeName
            });
        }

        if (!this.view) {
            this.view = new ChangelogPopup(this.viewModel, this.createRootElement('ChangelogPopup'));
        }

        return this.view.getTuple().view;
    }

}

ComponentManager.setFactory('ChangelogPopup', ChangelogPopupFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');